import CustomRouter from "./router/customRouter";
import './style.css'
import { useEffect } from "@wordpress/element";
import { history } from "./router";
import { routes } from "./admin/settings/routes";


function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hasLicenseParams =
      (params.get('page') === 'uavc' &&
        params.get('bsf-inline-license-form') === '6892199') ||
      params.get('status') === 'registered';

    if (hasLicenseParams) {
      // Remove activation-related parameters so the URL doesn't persist.
      params.delete('bsf-inline-license-form');
      params.delete('license_action');
      params.delete('token');
      params.delete('product_id');
      params.delete('purchase_key');
      params.delete('success');
      params.delete('status');

      params.set('page', 'uavc');
      params.set('tab', '1');

      const query = params.toString();
      history.replace(
        `${window.location.pathname}${query ? `?${query}` : ''}#${routes.settings.path}`
      );
    }
  }, []);

  return (
    <div className="App">
      <CustomRouter />
    </div>
  );
}

export default App;
